import styled, { css } from 'styled-components';

import BaseModal from './BaseModal';
import './styles.css';

const overlayClassName = 'styled-overlay-classname';
const modalClassName = 'styled-modal-classname';

interface StyledModalProps {
  mobileFullscreen?: boolean;
  mobileHeight?: string;
  fullScreen?: boolean;
  maxWidth?: string; // e.g. '960px'
  addPadding?: boolean;
}

const mobileFullscreenStyles = css`
  .${overlayClassName} {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: auto;
  }

  .${modalClassName} {
    min-height: 100%;
    width: 100%;

    border: none;
    box-shadow: none;
  }
`;

const fullscreenStyles = css`
  .${overlayClassName} {
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: auto;
    padding: 0;
  }

  .${modalClassName} {
    min-height: 100%;
    width: 100%;

    border: none;
    box-shadow: none;
  }
`;

const Modal = styled(BaseModal).attrs({
  overlayClassName,
  modalClassName
})<StyledModalProps>`
  .${overlayClassName} {
    position: fixed;
    z-index: ${({ theme }) => theme.layers.modal};
    inset: 0px;
    height: 100%;
    overflow-y: scroll;
    padding: 0px;
    margin: 0px;
    display: flex;
  }

  .${modalClassName} {
    background-color: #fff;
    ${({ addPadding }) => (addPadding ? 'margin: auto 20px;' : 'margin: auto;')}

    @media ${({ theme }) => theme.queries.minDesktop} {
      border-radius: 16px;
    }

    &:focus-visible {
      outline: none;
    }
  }

  ${({ mobileFullscreen }) => (mobileFullscreen ? mobileFullscreenStyles : '')}
  ${({ mobileHeight }) =>
    mobileHeight
      ? css`
          .${overlayClassName} {
            height: 100%;
            overflow-y: scroll;
            -webkit-overflow-scrolling: auto;
            align-items: flex-end;
          }
          .${modalClassName} {
            width: 100%;
            height: ${mobileHeight};
            margin: 0;
            border-top-left-radius: 16px;
            border-top-right-radius: 16px;
          }
        `
      : ''}

  @media ${({ theme }) => theme.queries.minTablet} {
    .${overlayClassName} {
      background-color: #0000007f;
    }

    .${modalClassName} {
      padding: 0px;
      height: auto;
      width: ${({ maxWidth }) => (maxWidth ? maxWidth : 'auto')};
      margin: auto;
    }
  }

  @media ${({ theme }) => theme.queries.minDesktop} {
    .${overlayClassName} {
      padding: 2% 0px;
    }
    .${modalClassName} {
      min-height: auto;
    }
  }

  ${({ fullScreen }) => (fullScreen ? fullscreenStyles : '')}
`;

export default Modal;
